import { Grid, Hidden, IconButton, Typography } from "@material-ui/core"
import React from "react"
import paperplaneLogo from "./../../assets/images/Logos/Group 36999.png"
import LinkedIn from "./../../assets/images/Footer/LinkedIn.png"
import Insta from "./../../assets/images/Footer/Instagram.png"
import Facebook from "./../../assets/images/Footer/Facebook.png"
import Twitter from "./../../assets/images/Footer/Twitter.png"
import { useNavigate } from "react-router"
import { colors } from "../../colors"
import { Copyright } from "@material-ui/icons"
import { NavLink } from "react-router-dom"
import isoLogo from "./../../assets/images/Footer/isoLogo.png"
import hipaLogo from "./../../assets/images/Footer/hippa.png"
function Footer({ isMobile }) {
  const whatsappLink = "a"
  const instagramLink = "b"
  const facebookLink = "c"
  const linkedInLink = "d"
  const navigate = useNavigate()
  const footerItems = [
    { to: "/vision", label: "About Us" },
    // { to: "/cancellationPolicy", label: "Cancellation Policy" },
   // { to: "/pricing", label: "Pricing" },
    { to: "/termsAndConditions", label: "Terms and Conditions" },
  ]
  const footerSocial = [
    {
      img: LinkedIn,
      to: "https://www.linkedin.com/company/paperplane-communications/",
    },
    { img: Facebook, to: "https://m.facebook.com/hq.paperplane/" },
    { img: Twitter, to: " https://twitter.com/hq_paperplane" },
    { img: Insta, to: "https://www.instagram.com/paperplanetech/" },
  ]
  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      style={{
        padding: isMobile ? "8% 10%" : "3% 8%",
        bottom: 0,

        minHeight: isMobile ? "60vh" : "40vh",
        background: "#F2F2F2",
      }}
    >
      <Grid
        item
        md={4}
        xs={12}
        // alignItems="center"
        container
        direction="column"
        spacing={3}
        style={{ marginTop: "1rem" }}
        justifyContent={"flex-start"}
      >
        <Grid item xs={12}>
          <img
            alt="Clinic Logo"
            src={paperplaneLogo}
            style={{
              objectFit: "contain",
              width: "175px",
              marginRight: "1rem",
            }}
          ></img>
        </Grid>
        <Grid item xs={12} container>
          <img
            src={isoLogo}
            alt="Iso compliant"
            style={{
              width: "75px",
              marginRight: "1.2rem",
              objectFit: "contain",
            }}
          />
          <img
            src={hipaLogo}
            alt="Iso compliant"
            style={{ width: "75px", objectFit: "contain" }}
          />
        </Grid>
      </Grid>

      <Grid
        container
        item
        md={8}
        spacing={2}
        xs={12}
        style={{ marginTop: "1rem" }}
        alignItems="center"
        justifyContent="space-between"
      >
        {footerItems.map((ele, idx) => (
          <Grid item key={idx}>
            <NavLink
              to={ele.to}
              onClick={() => window?.scrollTo(0, 0)}
              style={({ isActive }) => ({
                fontFamily: "Montserrat",
                textDecoration: "none",
                fontSize: "16px",
                textDecorationLine: "none",
                color: "black",
                fontWeight: "500",
              })}
            >
              {ele.label}
            </NavLink>
          </Grid>
        ))}
        <Hidden smDown>
          <Grid item>
            <NavLink
              to={"/privacyPolicy"}
              onClick={() => window?.scrollTo(0, 0)}
              style={({ isActive }) => ({
                fontFamily: "Montserrat",
                textDecoration: "none",
                fontSize: "16px",
                textDecorationLine: "none",
                color: "black",
                fontWeight: "500",
              })}
            >
              Privacy Policy
            </NavLink>
          </Grid>
        </Hidden>
        <Hidden mdUp>
          <Grid item container justifyContent="flex-end">
            <NavLink
              to={"/privacyPolicy"}
              onClick={() => window?.scrollTo(0, 0)}
              style={({ isActive }) => ({
                fontFamily: "Montserrat",
                textDecoration: "none",
                fontSize: "16px",
                textDecorationLine: "none",
                color: "black",
                fontWeight: "500",
              })}
            >
              About Us{" "}
            </NavLink>
          </Grid>
        </Hidden>
      </Grid>
      <Hidden mdUp>
        <Grid
          container
          item
          xs={12}
          md={6}
          justifyContent={isMobile ? "center" : "flex-end"}
          alignItems="center"
          style={{
            marginTop: "1rem",
          }}
        >
          {footerSocial.map((ele) => (
            <Grid item>
              <IconButton onClick={() => window.open(ele.to)}>
                <img
                  src={ele.img}
                  alt={ele.to}
                  style={{ color: colors.primary, width: "32px" }}
                ></img>
              </IconButton>
            </Grid>
          ))}
        </Grid>
      </Hidden>
      <Grid item md={6} xs={12} container style={{ marginTop: "1rem" }}>
        <Copyright fontSize="small" color="primary" />
        <Typography
          color="textSecondary"
          variant="body2"
          style={{ fontFamily: "Montserrat" }}
        >
          Copyright 2023 Paperplane Communications Pvt. Ltd.
          <br /> All Rights Reserved
        </Typography>
      </Grid>
      <Hidden smDown>
        <Grid
          container
          item
          xs={12}
          md={6}
          justifyContent={isMobile ? "center" : "flex-end"}
          alignItems="center"
          style={{
            marginTop: "1rem",
          }}
        >
          {footerSocial.map((ele) => (
            <Grid item>
              <IconButton onClick={() => window.open(ele.to)}>
                <img
                  src={ele.img}
                  alt={ele.to}
                  style={{ color: colors.primary, width: "32px" }}
                ></img>
              </IconButton>
            </Grid>
          ))}
        </Grid>
      </Hidden>
    </Grid>
  )
}

export default Footer
